import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/financial',
	name: 'financial',
	meta,
	redirect: {
		name: 'financial-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'dateFinancialStatement',
			name: `${pre}dateFinancialStatement`,
			component: _import('financial/dateOrderFinancialStatement'),
			meta: {
				...meta,
				title: '约会订单统计'
			}
		},
		{
			path: 'activityFinancialStatement',
			name: `${pre}activityFinancialStatement`,
			component: _import('financial/activityOrderFinancialStatement'),
			meta: {
				...meta,
				title: '报名缴费统计'
			}
		},
	])('financial-')
}